import React from 'react';
import cn from 'classnames';

import { timeStringFormatShortForm } from '@/common/lib/timer';
import { StringMain } from '@/components/Typography/Typography';
import {
  MainSmButton,
  PurpleButton,
  WatchSmButton,
} from '@/components/ui/Button/Button';
import { CurrencyImage } from '@/components/ui/CurrencyImage/CurrencyImage';

interface ChengeButtonProps {
  name: string;
  boxSeconds?: number;
  t: (key: string) => string;
  onBuyBox: () => void;
  statusVIP: boolean | undefined;
  isLoading?: boolean;
  tgem?: number;
  className?: string;
  disable?: boolean;
  extraText?: string;
}

const ChengeButton: React.FC<ChengeButtonProps> = ({
  name,
  boxSeconds = 0,
  t,
  onBuyBox,
  statusVIP,
  isLoading,
  tgem = 0,
  className,
  disable,
  extraText,
}) => {
  switch (name) {
    case 'free':
      return (
        <MainSmButton
          className={cn(className)}
          isLoading={isLoading}
          text={
            !boxSeconds
              ? t('Get Free')
              : timeStringFormatShortForm(boxSeconds * 1000)
          }
          inactive={!!boxSeconds}
          disabled={disable}
          onClick={onBuyBox}
        />
      );
    case 'ads':
      return (
        <WatchSmButton
          className={cn(className)}
          text={
            boxSeconds
              ? timeStringFormatShortForm(boxSeconds * 1000)
              : undefined
          }
          inactive={!!boxSeconds}
          disabled={disable}
          isVIP={statusVIP}
          isIconVisible={!!boxSeconds}
          onClick={onBuyBox}
        />
      );
    default:
      return (
        <PurpleButton
          onClick={onBuyBox}
          isLoading={isLoading}
          inactive={!!boxSeconds}
          disabled={disable}
          className={cn(className, 'flex items-center gap-1 isolate')}
        >
          {!boxSeconds ? (
            <>
              {extraText && (
                <StringMain weight="extrabold">{extraText}</StringMain>
              )}
              <CurrencyImage kind="tgem" size="1.25rem" />
              <StringMain weight="extrabold">{tgem}</StringMain>
            </>
          ) : (
            <StringMain weight="extrabold">
              {timeStringFormatShortForm(boxSeconds * 1000)}
            </StringMain>
          )}
        </PurpleButton>
      );
  }
};

export default ChengeButton;
